import { Button, Flex, Form, Modal } from 'antd';
import { useCallback, useState } from 'react';
import DeliveryManSelect from '../DeliveryManSelect';
import { notifyError } from '../../store/utils';
import { API } from '../../api';

interface ParcelOrderDeliveryManType {
  parcelOrderNos: number[];
  visible: boolean;
  onClose: () => void;
  onReload: () => void;
}

const ParcelOrderDeliveryMan = ({
  visible,
  parcelOrderNos,
  onClose,
  onReload,
}: ParcelOrderDeliveryManType) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const close = useCallback(() => {
    form.resetFields();
    onClose();
  }, []);

  const onFinish = useCallback(
    async (values: any) => {
      try {
        setLoading(true);
        const payload = {
          parcelOrderNos,
          deliveryManNo: values.deliveryManNo,
        };
        await API.post({ apiVersion: 'api' })(`/order/delivery/man/update`, payload);
        onClose();
        onReload();
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [parcelOrderNos]
  );

  return (
    <Modal title="Хүргэгч сонгох" open={visible} onCancel={() => close()} footer={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item label="ИА.Хүргэгч" name="deliveryManNo">
          <DeliveryManSelect />
        </Form.Item>
        <Form.Item>
          <Flex justify="end" gap={24}>
            <Button onClick={() => close()} disabled={loading} htmlType="button">
              Цуцлах
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Хадгалах
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ParcelOrderDeliveryMan;
